// Lazy Video Loading with Data-src + Swiper Integration
document.addEventListener('DOMContentLoaded', function() {
    console.log('Starting lazy video loading with data-src...');
    
    const videoContainers = document.querySelectorAll('[data-lazy-video]');
    const videoData = new Map();
    let hasUserInteracted = false;
    let swiper = null;
    
    console.log(`Found ${videoContainers.length} video containers`);

    // Initialize video containers
    videoContainers.forEach((videoContainer, index) => {
        const video = videoContainer.querySelector('[data-lazy-video-element]');
        
        if (!video) {
            console.log(`Container ${index + 1}: Missing video element`);
            return;
        }

        const videoId = video.dataset.videoId;
        const sourcesScript = document.querySelector(`[data-video-sources="${videoId}"]`);
        
        if (!sourcesScript) {
            console.log(`Container ${index + 1}: Missing sources script for video ID ${videoId}`);
            return;
        }

        let videoSources;
        try {
            videoSources = JSON.parse(sourcesScript.textContent);
        } catch (e) {
            console.error(`Container ${index + 1}: Failed to parse video sources JSON`, e);
            return;
        }

        let loaded = false;
        let isLoading = false;

        // Create load function for this video
        const loadVideo = function() {
            if (loaded || isLoading) return;
            
            isLoading = true;
            console.log(`Loading video ${index + 1} (ID: ${videoId})...`);
            
            if (!videoSources.sources || videoSources.sources.length === 0) {
                console.error(`Video ${index + 1}: No sources found in JSON data`);
                isLoading = false;
                return;
            }

            // Clear any existing sources first
            video.querySelectorAll('source').forEach(source => source.remove());

            // Create and add source elements from JSON data
            let sourcesAdded = 0;
            videoSources.sources.forEach((source, sourceIndex) => {
                if (source.url && source.type) {
                    const sourceElement = document.createElement('source');
                    sourceElement.src = source.url;
                    sourceElement.type = source.type;
                    video.appendChild(sourceElement);
                    sourcesAdded++;
                    console.log(`Video ${index + 1}: Added source ${sourceIndex + 1} - ${source.type}`);
                }
            });
            
            if (sourcesAdded === 0) {
                console.error(`Video ${index + 1}: No valid sources could be added!`);
                isLoading = false;
                return;
            }

            // Set video attributes for autoplay
            video.muted = true;
            video.loop = true;
            video.playsInline = true;
            video.preload = 'metadata';

            // Event listeners
            video.addEventListener('loadeddata', () => {
                console.log(`Video ${index + 1}: Data loaded`);
                loaded = true;
                isLoading = false;
                
                // Mark container as loaded
                videoContainer.classList.add('video-loaded');
                videoContainer.removeAttribute('data-lazy-video');
                
                // Remove the sources script tag to clean up DOM
                sourcesScript.remove();
                
                // Try to autoplay if conditions are met
                if (hasUserInteracted && shouldAutoplay(video)) {
                    attemptPlay(video, index + 1);
                }
            });

            video.addEventListener('error', (e) => {
                console.error(`Video ${index + 1}: Load error`, e);
                isLoading = false;
            });

            // Load the video
            video.load();
        };

        // Store the load function and video reference
        videoData.set(videoContainer, {
            loadVideo,
            video,
            loaded: () => loaded,
            isLoading: () => isLoading,
            index: index + 1,
            videoId
        });
    });

    // Function to attempt video play
    function attemptPlay(video, videoIndex) {
        if (video.readyState >= 2) { // HAVE_CURRENT_DATA
            video.play()
                .then(() => console.log(`Video ${videoIndex}: Playing!`))
                .catch(error => console.log(`Video ${videoIndex}: Autoplay failed - ${error.name}`));
        } else {
            // Wait for video to be ready
            const onCanPlay = () => {
                video.play()
                    .then(() => console.log(`Video ${videoIndex}: Playing after ready!`))
                    .catch(error => console.log(`Video ${videoIndex}: Delayed autoplay failed - ${error.name}`));
                video.removeEventListener('canplay', onCanPlay);
            };
            video.addEventListener('canplay', onCanPlay);
        }
    }

    // Function to check if video should autoplay
    function shouldAutoplay(video) {
        if (!hasUserInteracted) return false;
        
        // Check if video is in active Swiper slide
        if (swiper) {
            const activeSlide = swiper.slides[swiper.activeIndex];
            if (activeSlide && activeSlide.contains(video)) {
                return true;
            }
        }
        
        // Fallback: check if video is visible in viewport
        const rect = video.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && 
               rect.bottom >= 0 && rect.top <= window.innerHeight &&
               rect.left >= 0 && rect.right <= window.innerWidth;
    }

    // Setup user interaction detection - More restrictive for GTMetrix
    function setupUserInteraction() {
        const interactionEvents = ['click', 'touchstart', 'keydown']; // Removed 'scroll'
        
        const handleInteraction = (event) => {
            hasUserInteracted = true;
            console.log(`User interaction detected: ${event.type}`);
            
            // Now that user has interacted, set up intersection observer
            setupIntersectionObserver();
            
            // Load active Swiper videos if Swiper exists
            if (swiper) {
                loadActiveAndAdjacentVideos();
            } else {
                // Load visible videos for non-Swiper content
                loadVisibleVideos();
            }
            
            // Try to play active video after interaction
            setTimeout(() => {
                playActiveVideo();
            }, 100);
            
            // Remove listeners
            interactionEvents.forEach(evt => {
                document.removeEventListener(evt, handleInteraction);
            });
        };

        interactionEvents.forEach(event => {
            document.addEventListener(event, handleInteraction, { passive: true });
        });

        // Remove automatic fallback timer - wait for real user interaction
        // No setTimeout fallback for GTMetrix compatibility
    }

    // Setup Swiper integration
    function waitForSwiper() {
        let attempts = 0;
        const maxAttempts = 50; // 5 seconds
        
        const checkSwiper = () => {
            const swiperContainer = document.querySelector('[data-swiper-container]');
            attempts++;
            
            if (swiperContainer && swiperContainer.swiper) {
                swiper = swiperContainer.swiper;
                setupSwiperEvents();
                console.log('Swiper detected and integrated');
                
                // Don't load videos automatically - wait for user interaction
                // loadActiveAndAdjacentVideos();
            } else if (attempts >= maxAttempts) {
                console.log('Swiper not detected - loading visible videos');
                setTimeout(() => {
                    loadVisibleVideos();
                }, 500);
            } else {
                setTimeout(checkSwiper, 100);
            }
        };
        
        setTimeout(checkSwiper, 200);
    }

    function setupSwiperEvents() {
        if (!swiper) return;

        // Handle slide changes
        swiper.on('slideChangeTransitionEnd', () => {
            console.log(`Swiper slide changed to ${swiper.activeIndex}`);
            handleSlideChange();
        });

        // Don't handle initial slide automatically - wait for user interaction
        // handleSlideChange();
    }

    function loadActiveAndAdjacentVideos() {
        if (!swiper || !hasUserInteracted) return; // Added user interaction check

        const activeIndex = swiper.activeIndex;
        const totalSlides = swiper.slides.length;
        
        // Load active slide + 1 slide before and after
        const indicesToLoad = [
            activeIndex,
            (activeIndex - 1 + totalSlides) % totalSlides,
            (activeIndex + 1) % totalSlides
        ];

        indicesToLoad.forEach(index => {
            const slide = swiper.slides[index];
            if (slide) {
                const videoContainer = slide.querySelector('[data-lazy-video]');
                if (videoContainer && videoData.has(videoContainer)) {
                    const data = videoData.get(videoContainer);
                    console.log(`Loading video for slide ${index} (Video ${data.index})`);
                    data.loadVideo();
                }
            }
        });
    }

    function handleSlideChange() {
        // Pause all videos
        pauseAllVideos();
        
        // Load active and adjacent videos if not loaded
        loadActiveAndAdjacentVideos();
        
        // Play active video if user has interacted
        if (hasUserInteracted) {
            setTimeout(() => {
                playActiveVideo();
            }, 150); // Slightly longer delay for video to be ready
        }
    }

    function playActiveVideo() {
        if (swiper) {
            const activeSlide = swiper.slides[swiper.activeIndex];
            if (activeSlide) {
                const video = activeSlide.querySelector('.video-loaded [data-lazy-video-element]');
                if (video) {
                    attemptPlay(video, 'active');
                }
            }
        } else {
            // Fallback: play first visible video
            const visibleVideo = document.querySelector('.video-loaded [data-lazy-video-element]');
            if (visibleVideo) {
                attemptPlay(visibleVideo, 'visible');
            }
        }
    }

    function pauseAllVideos() {
        const allVideos = document.querySelectorAll('.video-loaded [data-lazy-video-element]');
        allVideos.forEach(video => {
            if (!video.paused) {
                video.pause();
            }
        });
    }

    // Function to load visible videos (fallback when no Swiper) - More restrictive
    function loadVisibleVideos() {
        // Only load visible videos if user has interacted
        if (!hasUserInteracted) {
            console.log('Skipping visible videos load - waiting for user interaction');
            return;
        }

        console.log('Loading visible videos...');
        let loadedCount = 0;
        
        videoContainers.forEach(container => {
            const rect = container.getBoundingClientRect();
            const isVisible = rect.width > 0 && rect.height > 0 && 
                             rect.bottom >= -100 && rect.top <= window.innerHeight + 100;
            
            if (isVisible && videoData.has(container)) {
                const data = videoData.get(container);
                console.log(`Loading visible video ${data.index}`);
                data.loadVideo();
                loadedCount++;
            }
        });
        
        console.log(`Loaded ${loadedCount} visible videos`);
        
        // Remove fallback loading - no videos should load without user interaction
    }

    // Setup intersection observer for non-Swiper content - More restrictive
    function setupIntersectionObserver() {
        // Only set up intersection observer if user has interacted
        // This prevents GTMetrix from loading videos during automated testing
        
        if (!hasUserInteracted) {
            console.log('Skipping intersection observer setup - waiting for user interaction');
            return;
        }

        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && entry.intersectionRatio >= 0.1) {
                        const videoContainer = entry.target;
                        
                        // Skip if this is inside a Swiper
                        if (videoContainer.closest('.swiper-slide')) {
                            return;
                        }
                        
                        if (videoData.has(videoContainer)) {
                            const data = videoData.get(videoContainer);
                            console.log(`Intersection: Loading video ${data.index}`);
                            data.loadVideo();
                            observer.unobserve(videoContainer);
                        }
                    }
                });
            },
            {
                threshold: 0.1,
                rootMargin: '100px'
            }
        );

        // Observe non-Swiper video containers
        videoContainers.forEach(container => {
            if (!container.closest('.swiper-slide')) {
                observer.observe(container);
            }
        });
    }

    // Initialize everything
    setupUserInteraction();
    waitForSwiper();
    // Don't setup intersection observer immediately - wait for user interaction
    // setupIntersectionObserver();

    // Debug utilities
    window.checkVideoStatus = function() {
        console.log('\n=== VIDEO STATUS ===');
        console.log(`User interacted: ${hasUserInteracted}`);
        console.log(`Swiper detected: ${!!swiper}`);
        
        let loaded = 0, loading = 0, waiting = 0;
        videoData.forEach((data, container) => {
            if (data.loaded()) {
                loaded++;
            } else if (data.isLoading()) {
                loading++;
            } else {
                waiting++;
            }
        });
        
        console.log(`Loaded: ${loaded}, Loading: ${loading}, Waiting: ${waiting}`);
    };

    window.forceLoadAll = function() {
        console.log('Force loading all videos...');
        videoData.forEach(data => data.loadVideo());
    };

    console.log('\nLazy video loading with data-src initialized!');
    console.log('Use checkVideoStatus() and forceLoadAll() for debugging');
});